import React, { Component } from 'react';
import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

export default class alertTransferences extends Component {
  render() {
    const alertWeb = {
      borderColor: '#ffffff00',
      backgroundColor: '#FDF5E6',
      borderRadius: '20px 20px 0 0 ',
      width: '100%',
      color: ' #A87000',
      fontWeight: 600,
      fontSize: '16px',
    };
    const alertWap = {
      borderColor: '#ffffff00',
      backgroundColor: '#FDF5E6',
      width: '100%',
      color: ' #A87000',
      fontWeight: 600,
      fontSize: '12px',
      display: 'flex',
      flexDirection: 'row',
    };

    return (
      <React.Fragment>
        {
        channel === constChannels.WEB ?
          <div
            className="alert"
            role="alert" style={channel === constChannels.WEB ? alertWeb : alertWap}
          >
            <span style={{ paddingRight: '1%' }}>
              <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 4.49L18.53 17.5H3.47L11 4.49ZM11 0.5L0 19.5H22L11 0.5ZM12 14.5H10V16.5H12V14.5ZM12 8.5H10V12.5H12V8.5Z" fill="#A87000" />
              </svg>
            </span>
              Si haces un retiro anticipado, la cantidad que retires ya no participará para bono
              ni como acumulado de regalo.
          </div>
        : <div
          className="alert"
          role="alert" style={channel === constChannels.WEB ? alertWeb : alertWap}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingRight: '10px',
              fontsize: '30px',
            }}
          >
            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 4.49L18.53 17.5H3.47L11 4.49ZM11 0.5L0 19.5H22L11 0.5ZM12 14.5H10V16.5H12V14.5ZM12 8.5H10V12.5H12V8.5Z" fill="#A87000" />
            </svg>
          </div>
          <div> Si haces un retiro anticipado, la cantidad que retires ya no participará para bono
            ni como acumulado de regalo.
          </div>
        </div>
      }
      </React.Fragment>
    );
  }
}
